import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from '../../component/addCategoryForm/addCategoryForm.module.css';
import { Add, closeCircle, Delete, UploadImg } from '../../Svg';
import styless from '../../component/scheduleComps/scheduleList/partList.module.css';
import NestedUserHeader from "../../component/reusable/NestedUserHeader";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { toast } from "react-toastify";
import axios from "axios";
import api from "../../utils/api";
import { addLoginBuilderThunk, getLoginBuilderThunk } from "../../redux/appearanceSlice";

const Accordions = styled(Accordion)(({ theme }) => ({
  borderRadius: '8px !important',
  boxShadow: 'none',
  border: `1px solid ${theme.palette.divider}`,
  margin: "20px 0px",
  fontFamily: `'Public Sans', sans-serif`,
  '&::before': {
    background: 'transparent',
    content: 'none',
  },
}));


const LoginPage = () => {
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch()

  const imageRef = useRef(null);
  const [loading, setLoading] = useState(false)
  const { heroBannerData ,login} = useSelector((state) => state.appearances)

  console.log(login);
  

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };



  useEffect(() => {
       dispatch(getLoginBuilderThunk())
  }, [])
  
  // General Information Formik
  const loginBuilderFormic = useFormik({
    initialValues: {
      image: login?.data?.image || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      image: Yup.string().required('image is required'),

    }),
    onSubmit: async (values) => {
      console.log(values);
      dispatch(addLoginBuilderThunk(values));
    },
  });

  const handleImageChange = async (e, attribute, repo) => {

    const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
    setLoading(true)
    try {
      if (file) {

        const body = {
          key: `${Date.now()}_${file.name}`,
          fileType: file.type,
          fileName: file.name,
        };

        const { data, status } = await api.getPutSignedUrl(body);
        if (status === 200) {
          await axios.put(data.data?.preSigned, file, {
            headers: {
              "Content-Type": file.type
            }
          })

          loginBuilderFormic.setFieldValue(attribute, data?.data?.url)
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Error uploading file")
    } finally {
      setLoading(false)
    }
  };

  const handleRemove = (repo) => {
    loginBuilderFormic.setFieldValue(repo, '');
  };




  return (
    <>

      <NestedUserHeader
        index="Login Page Builder"
        root="Dashboard"
        buttonText={'Back to list'}
      />

      <Box sx={{ width: '70%', }}>
        {/* Login Page Section */}
        <Accordions sx={{ marginBottom: "20px" }}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography sx={{
              fontSize: "16px",
              color: "#1D1F2C",
            }}>Login</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ background: '#F0F1F3B2', margin: "0px 20px 20px 20px" }}>
            <form onSubmit={loginBuilderFormic.handleSubmit}>
              <div className={styles.imageUpload}>

                <p className={styles.addCatLabel}>Banner Image</p>
                {loading ? <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>
                  please wait...
                </div> :
                  <>
                    {
                      loginBuilderFormic.values.image
                        ?
                        <div className={styles.uploadBox} style={{ background: '#fff', display: 'flex', justifyContent: 'center' }}>

                          <img src={loginBuilderFormic.values.image} alt="" className={styles.previewImage} />


                          <div className={styles.cancel_cross} onClick={() => handleRemove("image")}>
                            {closeCircle()}
                          </div>
                        </div>
                        :
                        <div
                          className={styles.uploadBox}
                          style={{ background: '#fff', cursor: 'pointer' }}
                          onClick={() => imageRef.current.click()}
                          onDrop={(e) => {
                            e.preventDefault();
                            handleImageChange(e, 'image', 'image');
                          }}
                          onDragOver={(e) => e.preventDefault()}

                        >
                          <span className={styles.uploadIcon}><UploadImg /></span>
                          <p className={styles.addCatPara}>Drag and drop image here, or click add image</p>

                          <button type="button" className={styles.addImgBtn} >Add Image/video</button>
                          <input
                            type="file"
                            name=""
                            id=""
                            ref={imageRef}
                            style={{ display: 'none' }}
                            onChange={(e) => handleImageChange(e, 'image', 'image')}
                            accept="image/*"
                          />
                        </div>
                    }
                  </>
                }
                {loginBuilderFormic.touched.image && loginBuilderFormic.errors.image && (
                  <div className={styles.errorText}>{loginBuilderFormic.errors.image}</div>
                )}
                <div style={{ margin: "10px 0px 10px 0px", display: 'flex', justifyContent: 'flex-end', gap: '20px' }}>
                  <button className={styless.cancelBtn} onClick={() => loginBuilderFormic.resetForm()}>Cancel</button>
                  <button className={styless.submitBtn} type="submit" >{loginBuilderFormic.isSubmitting ? 'please wait...' : 'Save changes'}</button>
                </div>

              </div>
            </form>
          </AccordionDetails>
        </Accordions>



      </Box>

    </>
  );
};

export default LoginPage;
